<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table">
    <div #header class="tr text-uppercase layout-row layout-align-start-center fade-element-in-only">

      <div class="th medium text-ellipsis layout-row layout-align-start-center flex-15">
        {{'Agent' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Missed Tasks' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Hours' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-15">
        {{'Start Time' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-15">
        {{'End Time' | translate}}
      </div>

      <div class="th large text-ellipsis flex">
        {{'Sequence' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-5">
        {{'Score' | translate}}
      </div>

      <div *ngIf="onAllowExpand" class="th xxxsmall text-ellipsis flex-5"></div>
    </div>

    <div class="full-height flex layout-column overflow-auto">

      <div *ngIf="isShowTotals && totals" class="tr layout-column">
        <div class="layout-row layout-align-start-center totals-row">
          <!--Agent-->
          <div class="td medium layout-row layout-align-start-center flex-15 text-ellipsis">
            <span class="br-body-2 font-weight-600 gray-100" translate>Totals</span>
          </div>

          <!--Missed Tasks-->
          <div class="td xsmall layout-row flex-10 text-ellipsis">
          </div>

          <!--Hours-->
          <div class="td xsmall layout-row flex-10 text-ellipsis">
          </div>

          <!--Start Time-->
          <div class="td xsmall layout-row flex-15 text-ellipsis"
               [class.performance-metric]="totals.startOnTimeScore >= 0"
               [class.good-score]="totals.startOnTimeScore >= 80"
               [class.average-score]="totals.startOnTimeScore > 60 && totals.startOnTimeScore < 80"
               [class.bad-score]="totals.startOnTimeScore <= 60">
            <span *ngIf="totals.startOnTimeScore >= 0" class="br-body-1 font-weight-600">{{totals.startOnTimeScore}}
              %</span>
          </div>

          <!--End Time-->
          <div class="td xsmall layout-row flex-15 text-ellipsis"
               [class.performance-metric]="totals.endOnTimeScore >= 0"
               [class.good-score]="totals.endOnTimeScore >= 80"
               [class.average-score]="totals.endOnTimeScore > 60 && totals.endOnTimeScore < 80"
               [class.bad-score]="totals.endOnTimeScore <= 60">
            <span *ngIf="totals.endOnTimeScore >= 0" class="br-body-1 font-weight-600">{{totals.endOnTimeScore}}%</span>
          </div>

          <!--Sequence-->
          <div class="td large layout-row layout-align-start-center flex"
               [class.performance-metric]="totals.correctSequenceScore >= 0"
               [class.good-score]="totals.correctSequenceScore >= 80"
               [class.average-score]="totals.correctSequenceScore > 60 && totals.correctSequenceScore < 80"
               [class.bad-score]="totals.correctSequenceScore <= 60"><span *ngIf="totals.correctSequenceScore >= 0"
                                                                           class="br-body-1 font-weight-600">{{totals.correctSequenceScore}}
            %</span>
          </div>

          <!--Route Score-->
          <div
            class="td xsmall layout-row layout-align-start-center flex-5 text-ellipsis full-height padding-left-0 padding-right-0">
            <app-bringoz-donut-chart [segments]="totalsWidgetConfiguration.segments"
                                     [pieChartConfiguration]="{
                                              width: isBigScreen ? 3.6 : 4.6,
                                              height: isBigScreen ?  2.6 : 3.6,
                                              fontSize:12
                                       }"
                                     [innerTextConfiguration]="totalsWidgetConfiguration.innerTextConfiguration">
            </app-bringoz-donut-chart>

          </div>

          <div class="td xxxsmall flex-5"></div>
        </div>

      </div>


      <app-agents-route-score-expandable-table-row class="item"
                                                   *ngFor="let agentRouteScore of agentsRouteScore; let index = index"
                                                   [agentRouteScore]="agentRouteScore"
                                                   [onAllowExpand]="onAllowExpand"
                                                   [expandedData]="expandedRowsMap[agentRouteScore.agentId]"
                                                   [isBigScreen]="isBigScreen"
                                                   (onToggleExpand)="onToggleExpand.emit($event)">

      </app-agents-route-score-expandable-table-row>

    </div>

    <!--    <div class="full-height flex layout-column">-->
    <!--      <cdk-virtual-scroll-viewport class="flex viewport"-->
    <!--                                   autosize>-->

    <!--        <app-agents-route-score-expandable-table-row class="item"-->
    <!--                                                     *cdkVirtualFor="let agentRouteScore of agentsRouteScore"-->
    <!--                                                     [agentRouteScore]="agentRouteScore"-->
    <!--                                                     [onAllowExpand]="onAllowExpand"-->
    <!--                                                     [expandedData]="expandedRowsMap[agentRouteScore.agentId]"-->
    <!--                                                     (onToggleExpand)="onToggleExpand.emit($event)">-->

    <!--        </app-agents-route-score-expandable-table-row>-->

    <!--      </cdk-virtual-scroll-viewport>-->
    <!--    </div>-->
  </div>

</div>
